const transitionEndEventName = () => {
  const elem = document.createElement("div")
  const transitions = {
    "transition": "transitionend",
    "OTransition": "otransitionend",
    "MozTransition": "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  }

  for (const key in transitions) {
    if (transitions.hasOwnProperty(key) && elem.style[key] !== undefined) {
      return transitions[key]
    }
  }
}

export { transitionEndEventName as default }
